import WrapWithPopover from "@/components/shared/WrapWithPopover.vue";
import { CurrencyValue } from "@/components/tableElements";
export default {
  name: "LTVCompositeBar",
  components: {
    WrapWithPopover,
    CurrencyValue
  },
  props: {
    values: {
      type: Array,
      default: () => []
    },
    min: {
      type: Number,
      default: 0
    },
    max: {
      type: Number,
      default: 100
    }
  },
  computed: {
    computedStyle() {
      return value => {
        const length = value?.value / this.max;
        return {
          width: length * 100 + "%",
          background: value?.color,
          height: "100%"
        };
      };
    }
  },
  method: {}
};